// extracted by mini-css-extract-plugin
export default {"BorderBlock":"styles_BorderBlock__5giZm"};